import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
// import { Home, Briefcase, RadioTower, HouseHeart } from "lucide-react";
import {
  FileText,
  Shield,
  Users,
  BarChart3,
  FileCheck,
  Landmark,
  TrendingUp,
  Building2,
  HeartPulse,
  UserCog,
} from "lucide-react";

import "swiper/css";
import "swiper/css/pagination";

/* ✅ Correct Data */
const INDUSTRIES = [
  {
    id: 1,
    icon: HeartPulse,
    title: "Healthcare",
    description:
      "Automate extraction of data from medical reports, insurance claims, patient records, and healthcare forms to improve efficiency and reduce administrative workload. ",
  },
  {
    id: 2,
    icon: Users,
    title: "Insurance",
    description:
      "Streamline claims processing, policy documentation, and risk assessment by automatically extracting key information from insurance documents. ",
  },
  {
    id: 3,
    icon: Shield,
    title: "Legal",
    description:
      "Organize and analyze contracts, agreements, legal notices, and case documents with intelligent data extraction and structured outputs. ",
  },
  {
    id: 4,
    icon: UserCog,
    title: "Human Resources",
    description:
      "Simplify employee record management, onboarding documents, resumes, and compliance paperwork with automated document processing.",
  },
  {
    id: 5,
    icon: BarChart3,
    title: "Procurement & Supply Chain",
    description:
      "Manage invoices, purchase orders, supplier contracts, and logistics documents by converting them into structured data for faster operations.",
  },
  {
    id: 6,
    title: "Banking & Finance ",
    description:
      "Automate processing of financial documents such as bank statements, loan applications, and KYC records to improve accuracy, reduce manual effort, and accelerate decision-making. ",
    icon: Landmark,
  },
  {
    id: 7,
    title: "Sales",
    description:
      "Streamline sales operations by extracting data from proposals, contracts, and invoices, enabling faster document creation, processing, and deal closures. ",
    icon: TrendingUp,
  },
  {
    id: 8,
    title: "Commercial Real Estate",
    description:
      "Simplify handling of leases, property documents, and agreements by converting unstructured data into organized insights for faster transactions and better portfolio management. ",
    icon: Building2,
  },
];

/* ✅ Card Component */
const IndustryCard = ({ industry }) => {
  const Icon = industry.icon;

  return (
    <div className=" rounded-[4px] group flex flex-col justify-between h-full min-h-[220px] p-6 md:p-8 rounded-[4px] bg-white border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1">
      {/* Icon */}
      <div className="mb-5 flex items-center justify-center w-12 h-12 rounded-[4px] bg-gray-100">
        <Icon className="w-6 h-6 text-primary" />
      </div>

      {/* Title */}
      <h3 className="text-base md:text-lg font-semibold text-neutral-950 mb-2 group-hover:text-primary transition-colors">
        {industry.title}
      </h3>

      {/* Description */}
      <p className="text-sm text-neutral-600">{industry.description}</p>
    </div>
  );
};

/* ✅ Section */
export default function IndustriesWeServe() {
  return (
    <section className="section-padding bg-gray-100">
      <div className="container-width">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-semibold mb-4">
            <span className="text-primary">Industries</span>{" "}
            <span className="text-neutral-950">We Serve</span>
          </h2>

          <p className="text-neutral-600 max-w-2xl mx-auto text-sm md:text-base">
            Our clients are more than customers; they’re collaborators in
            transformation.
          </p>
        </div>

        {/* Swiper */}
        <div className="pb-12">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            pagination={{
              clickable: true,
              el: ".custom-pagination",
            }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              640: { slidesPerView: 1.2 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1280: { slidesPerView: 4 },
            }}
          >
            {INDUSTRIES.map((item) => (
              <SwiperSlide key={item.id} className="!h-auto">
                <IndustryCard industry={item} />
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Pagination */}
          <div className="custom-pagination mt-6 flex justify-center" />
        </div>
      </div>
    </section>
  );
}
